var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailColor(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9996 11.5086C15.9996 13.7097 14.2324 15.4928 12.0312 15.5006H12.0233H4.20488C2.01161 15.5006 0.220703 13.7255 0.220703 11.5244V11.5165C0.220703 11.5165 0.225437 8.0246 0.231748 6.26841C0.232537 5.93863 0.611231 5.75401 0.869216 5.95914C2.74375 7.4463 6.09598 10.1579 6.13779 10.1934C6.69794 10.6423 7.40799 10.8956 8.13382 10.8956C8.85965 10.8956 9.5697 10.6423 10.1299 10.1847C10.1717 10.1571 13.4489 7.52677 15.3519 6.01516C15.6107 5.80924 15.9909 5.99385 15.9917 6.32284C15.9996 8.06562 15.9996 11.5086 15.9996 11.5086Z",
    fill: "#1080FF",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5878 3.40847C14.9045 2.12091 13.5602 1.29883 12.0801 1.29883H4.20644C2.72638 1.29883 1.38201 2.12091 0.698788 3.40847C0.545732 3.69643 0.618315 4.0554 0.873145 4.25895L6.73106 8.94449C7.14131 9.27585 7.63835 9.44074 8.13538 9.44074C8.13854 9.44074 8.14091 9.44074 8.14327 9.44074C8.14564 9.44074 8.1488 9.44074 8.15116 9.44074C8.6482 9.44074 9.14523 9.27585 9.55548 8.94449L15.4134 4.25895C15.6682 4.0554 15.7408 3.69643 15.5878 3.40847Z",
    fill: "#1080FF",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailColor);
export default __webpack_public_path__ + "static/media/email_color.2b12b805a7870f7d95014a8d5e2fac2c.svg";
export { ForwardRef as ReactComponent };